import React from 'react';
import { Grid, Box } from '@material-ui/core';

import TopViewAction from './actions/TopViewAction';
import BottomViewAction from './actions/BottomViewAction';
import RecordingList from './record/RecordingList';
import { StudioControlStyles } from '../styles';
import SelectMediaDeviceAction from './actions/SelectMediaDeviceAction';
import SelectAudioDeviceAction from "./actions/SelectAudioDeviceAction";

type Props = {
  bottomViewContainerId: string;
  videoDevices: MediaDeviceInfo[];
  audioDevices: MediaDeviceInfo[];
};

const CameraSettingsPanelMobile = ({ bottomViewContainerId, videoDevices, audioDevices }: Props) => {
  const classes = StudioControlStyles();

  return (
    <>
      <Grid
        item
        container
        direction="column"
        style={{
          width: '100%',
          height: '100%',
          maxWidth: 'calc(100% - 170px)',
        }}
      >
        <SelectMediaDeviceAction videoDevices={videoDevices}/>
        <SelectAudioDeviceAction audioDevices={audioDevices}/>
        <Box mt={2}>
          <RecordingList />
        </Box>
      </Grid>
      <Grid
        item
        container
        style={{
          width: 170,
          height: '100%',
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <TopViewAction />
          </Grid>
          <Grid item xs={6}>
            <BottomViewAction />
          </Grid>
        </Grid>
        <Grid
          container
          className={classes.studioBottomView}
          id={bottomViewContainerId}
        >
        </Grid>
      </Grid>
    </>
  );
};

export default CameraSettingsPanelMobile;
